<template>
  <div>
    <form class="container">
      <fieldset>
        <div class="line">
          <h3>{{room.name}}</h3>
        </div>
        <div class="line">
          <h3>{{displayDate}}</h3>
        </div>
        <div class="line">
          <div class="center-wrap title">
            <input class="right" id="edit-title" type='text' v-model='booking.title' placeholder="Varauksen otsikko"/>
          </div>
        </div>
        <div class="line">
          <div class="center-wrap">
            <label>Alkaa:</label
            ><TimePicker class="picker right" v-model='booking.start' @change="onChange($event)"></TimePicker>
          </div>
        </div>
        <div class="line">
          <div class="center-wrap">
            <label>Päättyy:</label
            ><TimePicker class="picker right" v-model='booking.end' @change="onChange($event)"></TimePicker>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TimePicker from '@/components/TimePicker';

import TimeUtils from './../utils/TimeUtils';

export default {
  name: 'BookingEditForm',
  props: [ 'booking' ],
  methods: {
    onChange (event) {
      this.$emit('change', event);
    }
  },
  components: { TimePicker },
  computed: {
    displayDate () {
      return TimeUtils.toFIN(this.booking.date);
    },
    rooms () {
      return this.getRooms();
    },
    room () {
      return this.getRoomById(this.booking.roomId);
    },
    ...mapGetters('Room', ['getRoomById', 'getRooms'])
  }
}
</script>

<style lang="scss" scoped>
  @import 'src/color.scss';

  form, fieldset, h3 {
    padding: 0;
    margin: 0;
  }

  fieldset {
    border: none;
  }

  .line {
    display: flex;
    margin-bottom: 0.5em;
    justify-content: center;
    align-items: baseline;
  }

  .line label {
    text-align: right;
    padding-right: 0.5em;
    width: 4.5em;
  }

  .center-wrap {
    display: flex;
    justify-content: center;
    flex-flow: row wrap;
    align-items: center;
    width: 100%;
    //max-width: 16em;

    &.title {
      align-items: baseline;
    }

    input {
      padding: 0.2em 0.8em;
      font-size: 110%;
      width: 100%;
      max-width: 400px;
      border-width: 0 0 1px 0;
      border-color: $primary;
      text-align: center;
    }
  }

  .line .center-wrap .picker {
    justify-content: flex-end;
  }

  input {
    margin-bottom: 1em;
    box-sizing: border-box;
  }

</style>



// WEBPACK FOOTER //
// src/components/BookingEditForm.vue